import * as React from "react";

import { Alert } from "@replo/design-system/blocks/alert/Alert";
import { useCurrentWorkspace } from "@v2/contexts/WorkspaceDashboardContext";

import useHasFailedPayment from "./hooks/useHasFailedPayment";
import { getStripePortalUrl } from "./shared/sharedBillingUtils";

const PaymentFailedBanner = () => {
  const hasFailedPayment = useHasFailedPayment();
  const workspace = useCurrentWorkspace();
  const workspaceId = workspace?.id;

  if (!hasFailedPayment) {
    return null;
  }

  const handleUpdatePayment = () => {
    if (workspaceId) {
      window.open(getStripePortalUrl(workspaceId), "_blank");
    }
  };

  return (
    <Alert
      variant="error"
      title="Payment method failed"
      description="Your subscription will be cancelled soon if you do not take action."
      action={{ text: "Update Payment", onClick: handleUpdatePayment }}
    />
  );
};

export default PaymentFailedBanner;
